import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchClientSecret = (cartItems: any[], apiUrl: string) => {
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [customerId, setCustomerId] = useState<string | null>(null);

  useEffect(() => {
    const fetchClientSecret = async () => {
      try {
        const amount = cartItems.reduce((total: any, item: any) => total + item.totalPrice, 0);
        if (amount <= 0) {
          console.error('Total amount is zero or negative:', amount);
          setClientSecret(null);
          setCustomerId(null);
          return;
        }

        // Generate a unique order number (e.g., using a timestamp or a UUID)
        const orderNumber = `ORD-RAJAMAA-${Date.now()}`;

        const payload = {
          amount,
          currency: 'EUR',
          description: `Payment for order #${orderNumber}`,
          PaymentMethodTypes: ['card'], // Ensure this matches the backend expectation
          items: cartItems.map((item: any) => ({
            packageId: item.packageId,
            pricingModelId: item.pricingModelId,
            arrivalDate: item.arrivalDate,
            departureDate: item.departureDate,
            pricePerNight: item.pricePerNight
          }))
        };

        console.log('Request payload:', payload);

        interface PaymentIntentResponse {
          clientSecret: string;
          customerId: string;
        }

        const response = await axios.post<PaymentIntentResponse>(`${apiUrl}/Payments/createPaymentIntent`, payload);

        if (response.data && response.data.clientSecret && response.data.customerId) {
          setClientSecret(response.data.clientSecret);
          setCustomerId(response.data.customerId);
          console.log('Client secret:', response.data.clientSecret);
          console.log('Customer ID:', response.data.customerId);
        } else {
          throw new Error('Invalid response from server');
        }
      } catch (error) {
        console.error('Error fetching client secret:', error);
        setClientSecret(null);
        setCustomerId(null);
      }
    };

    if (cartItems.length > 0) {
      fetchClientSecret();
    } else {
      setClientSecret(null);
      setCustomerId(null);
    }
  }, [cartItems, apiUrl]);

  return { clientSecret, customerId };
};

export default useFetchClientSecret;